"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROTOCOLS_BY_ASSET = void 0;
const protocols_1 = require("../protocols");
exports.PROTOCOLS_BY_ASSET = {
    WSOL: [
        protocols_1.Protocols.Mango,
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Port,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
    ],
    mSOL: [
        protocols_1.Protocols.Mango,
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Port,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
        protocols_1.Protocols.SolendStablePool,
    ],
    USDC: [
        protocols_1.Protocols.Mango,
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Port,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
        protocols_1.Protocols.SolendStablePool,
    ],
    USDT: [
        protocols_1.Protocols.Mango,
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Port,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
        protocols_1.Protocols.SolendStablePool,
    ],
    BTC: [
        protocols_1.Protocols.Mango,
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Port,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
    ],
    soETH: [
        protocols_1.Protocols.Mango,
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
    ],
    SRM: [
        protocols_1.Protocols.Mango,
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Port,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
    ],
    MNGO: [protocols_1.Protocols.Mango],
    stSOL: [
        protocols_1.Protocols.Solend,
        protocols_1.Protocols.Port,
        protocols_1.Protocols.Tulip,
        protocols_1.Protocols.Francium,
    ],
    RAY: [protocols_1.Protocols.Mango, protocols_1.Protocols.Solend, protocols_1.Protocols.Tulip, protocols_1.Protocols.Francium],
    ORCA: [protocols_1.Protocols.Solend, protocols_1.Protocols.Tulip, protocols_1.Protocols.Francium],
};
//# sourceMappingURL=protocolsByAsset.js.map